import { DatadescriptionData } from "./datadescriptiondata.model";

export class DatadescriptionDescription {
  ID;
  Caption: string;
  Datadescription: DatadescriptionData;
}
